import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FeesStepInstance } from 'services/professional/step/step.interface';
import { Subject } from 'rxjs';
import { StepService } from 'services/professional/step/step.service';
import { MessageQueryService } from '@certemy/ui-components';
import { FeesScreens, getFeeFormOptionsForPayment } from '../fees-details.modal.component';
import _get from 'lodash-es/get';

@Component({
  selector: 'cm-fees-third-party-screen',
  templateUrl: './fees-third-party-screen.component.html',
  styleUrls: ['./fees-third-party-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeesThirdPartyScreenComponent implements OnDestroy {
  @Input() step: FeesStepInstance;
  @Output() closeModal = new EventEmitter();
  @Output() switchScreen = new EventEmitter();
  @Output() toggleMode = new EventEmitter();
  @Output() dismissModal = new EventEmitter();
  readonly FeesScreens = FeesScreens;
  onDestroy$ = new Subject<void>();
  commentText = '';

  constructor(private stepService: StepService, private messageService: MessageQueryService) {}

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  goToInitial() {
    this.switchScreen.emit(this.FeesScreens.Initial);
    this.toggleMode.emit();
  }

  onConfirm() {
    const feesFormFields = _get(this.step.content, 'feesFormFields', []) || [];
    const feeFormOptions = getFeeFormOptionsForPayment(feesFormFields);
    const data = {
      comment: this.commentText,
      ...(feeFormOptions.length ? { optionInstances: feeFormOptions } : {}),
    };

    this.stepService.confirmThirdPartyPayment(this.step.step_instance_id, data).subscribe(() => {
      this.messageService.addMessage('Job to inform Admin on payment condition was successfully created.');
      this.closeModal.emit();
    });
  }
}
